export default {
  namespaced: true,
  alarm_rules: {
    title: "Reglas",
    rule_id: "ID",
    name: "Nombre",
    description: "Descripción",
    user_id: "Usuario",
    tenant_id: "Tenant",
  },
  match_rules: {
    name_label: "Ingresa nombre identificador",
    description_label: "Ingresa descripción",
    tenant_label: "Asigna tenants a la regla",
    alarm_type_label: "Asigna el tipo de alarma a la regla",

    general: "Datos generales de la regla",
    providers: "Proveedores",
    camera: "Cámaras",
    table: "Tabla de coincidencias",

    assign_provider: "Asignar proveedores",
    assign_camera: "Asignar cámaras",
    main_camera: "Selecciona las cámaras a asignar",
    main_provider: "Selecciona los provedores a asignar",
    second_provider: "Selecciona un proveedor para mostrar su catalogo de campos",
    missing_provider: "Debes seleccionar un proveedor",
    min_match_rule: "Debes agregar al menos 1 coincidencia",
    new_match_rule: "Agregar nueva coincidencia",

    tenant: "Tenant",
    name: "Nombre de la regla",
    description: "Descripción",
    provider: "Proveedor",
    alarm_type: "Tipo de alarma",

    field: "Catalogo de campos",
    action: "Acción",
    type: "Tipo",
    value: "Valor"
  },
  match_rules_action: {
    contains: "Contiene",
    equal_to: "Igual a",
    no_equal_to: "Diferente de",
    greater_than: "Mayor que",
  },
  match_rules_card: {
    camera_applied: "Las coincidencias se aplicarán siempre y cuando las cámaras sean:",
    provider_applied: "Las coincidencias se aplicarán siempre y cuando los proveedores sean:",
    match_rule_table: "La tabla de coincidencias solo aplican para los provedores, cámaras y tenants asignados",

    apply_to: "Aplicar coincidencia:",
    on_param: "Sobre el parámetro:",
    with_values: "Con valor: | Con valores:"
  }
};
